import { useCallback, useEffect, useState } from 'react';
import { listAuditLogs } from '@/services/audit';
import type { AuditEntityType, AuditLog } from '@/types/audit';

export function useEntityAuditTrail(
  entityType: AuditEntityType,
  entityId: string | undefined,
) {
  const [logs, setLogs] = useState<AuditLog[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    if (!entityId) {
      setLogs([]);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const list = await listAuditLogs({
        entityType,
        entityId,
        limit: 50,
      });
      setLogs(list);
    } catch {
      setError('No se pudo cargar el historial de cambios.');
    } finally {
      setLoading(false);
    }
  }, [entityType, entityId]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { logs, loading, error, refresh };
}
